import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

const HeadingInline = (props) => {
    const [container, setContainer] = useState(null);

   useEffect(() => {
        let attempts = 0;
        const interval = setInterval(() => {
            const el = document.getElementById(props.field.containerId);
            if (el) {
            setContainer(el);
            clearInterval(interval);
            } else if (attempts++ > 10) {
            clearInterval(interval);
            console.warn("Portal container not found:", props.field.containerId);
            }
        }, 100); // retry every 100ms up to 1s

    return () => clearInterval(interval);
    }, [props.field.containerId]);
    if (!container) return null;

    return  ReactDOM.createPortal(

        <div key={props.objectkey}  
            id={props.objectkey} 
            className={`heading field heading-inline ${props.field.class || ""}`}>
                
                 <h2>{props.field.fieldValue}</h2>

        </div>  
        ,container // <- target container   
    );
}
export default HeadingInline;